__turbopack_context__.v({
  "modalBody": "LegalDisclaimers-module__DfB59a__modalBody",
  "modalContainer": "LegalDisclaimers-module__DfB59a__modalContainer",
});
